
import { defineComponent, reactive, toRefs, ref } from 'vue'
import CUpload from '@/components/c-upload'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { getToken } from '@/utils/auth'
import { setBaseUrl } from '@/config/url'
import { setAddEnterprise } from './api'
import {
  rules,
  economicsStatusMap,
  economicsTypeMap,
  customerTypeOpt,
} from './config'
import { regionData } from 'element-china-area-data'
import moment from 'moment'

export default defineComponent({
  components: { CUpload },
  setup() {
    const data = reactive({
      formData: {
        collectivized: 0,
        systemType: 1,
        techProvider: '',
        customerType: 1,
        systemName: '蓝鲸车管家',
        systemPattern: 2,
        chargeSms: 1,
        violationSync: 1,
        violationContractAdd: 2,
        violationContractAddCount: '',
        violationContractTransfer: 2,
        violationContractTransferCount: '',
        electronicType: null,
      },
      accountAddressOptions: regionData,
      rules,
      economicsStatusMap,
      economicsTypeMap,
      customerTypeOpt,
      action:
        setBaseUrl().uploadUrl + '/ccclubs-file-center/common/file/uploadFile',
      headers: {
        token: getToken(),
      },
    })
    const router = useRouter()
    const formRef = ref<HTMLElement | any>(null)
    const violationContractAddCountError = ref('')
    const violationContractTransferCountError = ref('')
    const validateCustomFields = (): boolean => {
      violationContractAddCountError.value = ''
      violationContractTransferCountError.value = ''
      let valid = true
      if (data.formData.violationContractAdd === 2 && data.formData.violationContractAddCount) {
        if (!/^[0-9]{1,7}$/.test(data.formData.violationContractAddCount)) {
          violationContractAddCountError.value = '请输入1-7位数字'
          valid = false
        }
      }
      if (data.formData.violationContractTransfer === 2 && data.formData.violationContractTransferCount) {
        if (!/^[0-9]{1,7}$/.test(data.formData.violationContractTransferCount)) {
          violationContractTransferCountError.value = '请输入1-7位数字'
          valid = false
        }
      }
      return valid
    }
    const back = () => {
      router.back()
    }
    const uploadBLSuccess = (file) => {
      ; (data.formData as any).businessLicenseJpg = file.response.data.filename
    }
    const uploadMPSuccess = (file) => {
      ; (data.formData as any).managePermissionJpg = file.response.data.filename
    }
    const uploadBLRemove = () => {
      if ((data.formData as any).businessLicenseJpg) {
        ; (data.formData as any).businessLicenseJpg = null
      }
    }
    const changeManageTimeStar = (o) => {
      if (o) {
        ; (data.formData as any).manageTimeStar = moment(
          (data.formData as any).manageTimeStar
        ).format('YYYY-MM-DD')
      }
    }
    const changeManageTimeEnd = (o) => {
      if (o) {
        ; (data.formData as any).manageTimeEnd = moment(
          (data.formData as any).manageTimeEnd
        ).format('YYYY-MM-DD')
      }
    }
    const changeManageTimeFirst = (o) => {
      if (o) {
        ; (data.formData as any).manageTimeFirst = moment(
          (data.formData as any).manageTimeFirst
        ).format('YYYY-MM-DD')
      }
    }
    const uploadMPRemove = () => {
      if ((data.formData as any).managePermissionJpg) {
        ; (data.formData as any).managePermissionJpg = null
      }
    }
    const creatSumbit = (): void => {
      if (!validateCustomFields()) {
        ElMessage.warning('表单校验不正确')
        return
      }
      formRef.value.validate((valid: boolean) => {
        if (valid) {

          const params = JSON.parse(JSON.stringify(data.formData))
          params.contactsAreaCode =
            params.contactsAreaCode && params.contactsAreaCode.join(',')
          setAddEnterprise(params).then(() => {
            ElMessage.success('添加成功')
            back()
          })
        } else {
          ElMessage.warning('表单校验不正确')
        }
      })
    }
    return {
      formRef,
      ...toRefs(data),
      creatSumbit,
      back,
      uploadBLSuccess,
      uploadMPSuccess,
      uploadBLRemove,
      uploadMPRemove,
      changeManageTimeStar,
      changeManageTimeFirst,
      changeManageTimeEnd,
      violationContractAddCountError,
      violationContractTransferCountError,
    }
  },
})
